import { Inview } from './utility';

export default function inview() {
  document.querySelectorAll('.js-inview').forEach((element) => {
    Inview.add(element);
  });
}
